import React, { useState } from "react";

import "../MedicalHistory/MedicalHistory.css";
import "../../Components/Commons/Commons.css";
import "quill/dist/quill.snow.css";
import "chart.js/auto";

import BtnAdd from "../Commons/Buttons/BtnAdd";
import TextField from "../Commons/Forms/TextField";
import TextArea from "../Commons/Forms/TextArea";
import BtnSave from "../Commons/Buttons/BtnSave";
import AntDTable from "../AntDTable/AntDTable";
import SelectField from "../Commons/Forms/SelectField";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import DeleteModal from "../Modals/DeleteModal";
import DateField from "../Commons/Forms/DateField";
import SocialPersonalHistorySummary from "../PatientProfile/SocialPersonalHistorySummary";
import dayjs from "dayjs";

import { Form, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Checkbox, DatePicker, InputNumber, List, Radio } from "antd";
import {
  createDrinking,
  createDrug,
  createHerbal,
  createSexualActivity,
  createSmoking,
  deleteDrinking,
  deleteDrug,
  deleteHerbal,
  deleteSexualActivity,
  deleteSmoking,
  editDrinking,
  editDrug,
  editHerbal,
  editSexualActivity,
  editSmoking,
  getDrinking,
  getDrug,
  getHerbal,
  getSexualActivity,
  getSmoking,
} from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi";
import { getRole } from "../Helpers/Utilities/Common";
import { toast } from "react-toastify";
import {
  validateDrinking,
  validateDrug,
  validateHerbal,
  validateSmoking,
} from "../Helpers/Utilities/Validations/MedicalHistoryHospitalization";
import { formatDate } from "../../Assets/Helpers/Common";

function AddSocialPersonal({ smokingDatas, setSmokingDatas }) {
  const id = useParams();
  const role = getRole();
  const [showDelete, setShowDelete] = useState(false);
  const [showLoader, setShowLoader] = useState(false); // table loader
  const [showButton, setShowButton] = useState(false); // button loader
  const [selectedItem, setSelectedItem] = useState(0);
  const [isMedicalHistory, setIsMedicalHistory] = useState(true);
  const [isSelected, setIsSelected] = useState("Smoking");

  const [isError, setError] = useState({
    name: false,
    admitted_on: false,
    reason: false,
    type: false,
    duration: false,
    last_attack: false,
    usual_fbs: false,
    usual_rbs: false,
    hba1c: false,
    cbg_range: false,
    complications: false,
    generic: false,
    brand: false,
    preparation: false,
    form: false,
    dosage: false,
    frequency: false,
    timing: false,
    compliance: false,
    highest_bp: false,
    usual_bp: false,
    last_intake: false,
    medication: false,
    rai: false,
    surgery: false,
    levothyroxine: false,
    histopathologic: false,
    sticks_per_day: false,
    consumption: false,
    aog: false,
    fasting: false,
    glucose_load_1h: false,
    glucose_load_2h: false,
    insulin_use: false,
    handout_link: false,
    gdm_profile_id: false,
    others: false,
    vax_shot_id: false,
    taken_on: false,
    next_shot_on: false,
  });
  const [addHerbal, setAddHerbal] = useState({
    id: "",
    name: "",
    last_intake: "",
    duration: "",
  });
  const [addSmoking, setAddSmoking] = useState({
    id: "",
    duration: "",
    sticks_per_day: "",
  });
  const [addDrinking, setAddDrinking] = useState({
    id: "",
    frequency: "occasional",
    consumption: "light",
    btl_per_day: "",
  });
  const [addDrug, setAddDrug] = useState({
    id: "",
    name: "",
    last_intake: "",
  });
  const [addSexualActivity, setAddSexualActivity] = useState({
    id: "",
    is_sexually_active: "0",
  });

  const [herbalDatas, setHerbalDatas] = useState([]);
  const [smokingData, setSmokingData] = useState([]);
  const [drinkingDatas, setDrinkingDatas] = useState([]);
  const [drugDatas, setDrugDatas] = useState([]);
  const [SexualActivityData, setSexualActivityData] = useState([]);
  const [isEdit, setIsEdit] = useState("");

  // List fo tabs in Add Medical
  const listTabs = [
    { id: 0, label: "Smoking" },
    { id: 1, label: "Drinking" },
    { id: 2, label: "Illicit Drug Use" },
    { id: 3, label: "Herbal Use" },
    { id: 4, label: "Sexual Activity" },
  ];

  // Function for handling the value in add medical tab
  const handleChange = (data, index) => {
    setSelectedItem(index);
    setIsSelected(data.label);
  };

  // Function for handling the value in Herbal tab
  const handleAddHerbalChange = (e) => {
    const { name, value } = e.target;
    setAddHerbal((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Smoking tab
  const handleAddSmokingChange = (e) => {
    const { name, value } = e.target;
    setAddSmoking((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Drinking tab
  const handleAddDrinkingChange = (e) => {
    const { name, value } = e.target;
    setAddDrinking((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function for handling the value in Frug tab
  const handleAddDrugChange = (e) => {
    const { name, value } = e.target;
    setAddDrug((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSexualActivityChange = (e) => {
    const { name, value } = e.target;
    setAddSexualActivity((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /** API -- SMOKING */
  async function addSmokingSubmit() {
    setShowButton(true);
    if (validateSmoking(addSmoking, setError)) {
      const response = await createSmoking(addSmoking, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        setIsSelected("Smoking");
        setAddSmoking({ duration: "", sticks_per_day: "" });
        fetchSmoking();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateSmoking() {
    setShowButton(true);
    if (validateSmoking(addSmoking, setError)) {
      const response = await editSmoking(addSmoking, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddSmoking({ duration: "", sticks_per_day: "" });
        setIsEdit("");
        fetchSmoking();
      }
    }
    setShowButton(false);
  }
  async function deleteSmokingSubmit() {
    const response = await deleteSmoking(addSmoking.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddSmoking({ ...addSmoking, duration: "", sticks_per_day: "" });
      fetchSmoking();
    }
  }
  async function fetchSmoking() {
    setShowLoader(true);
    const response = await getSmoking({ patient_id: id.id });
    if (response.data) {
      setSmokingData(response.data.data);
    } else {
      setSmokingData([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- DRINKING */
  async function addDrinkingSubmit() {
    setShowButton(true);
    if (validateDrinking(addDrinking, setError)) {
      const response = await createDrinking(addDrinking, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        setIsSelected("Drinking");
        setAddDrinking({
          frequency: "occasional",
          consumption: "light",
          btl_per_day: "",
        });
        fetchDrinking();
      }
    } else {
      toast.error("Please enter all required fields.");
    }
    setShowButton(false);
  }
  async function updateDrinking() {
    setShowButton(true);
    if (validateDrinking(addDrinking, setError)) {
      const response = await editDrinking(addDrinking, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddDrinking({
          frequency: "occasional",
          consumption: "light",
          btl_per_day: "",
        });
        setIsEdit("");
        fetchDrinking();
      }
    }
    setShowButton(false);
  }
  async function deleteDrinkingSubmit() {
    const response = await deleteDrinking(addDrinking.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddDrinking({
        frequency: "occasional",
        consumption: "light",
        btl_per_day: "",
      });
      fetchDrinking();
    }
  }
  async function fetchDrinking() {
    setShowLoader(true);
    const response = await getDrinking({ patient_id: id.id });
    if (response.data) {
      setDrinkingDatas(response.data.data);
    } else {
      setDrinkingDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- ILLICIT DRUG USE */
  async function addDrugUse() {
    setShowButton(true);
    if (validateDrug(addDrug, setError)) {
      // if(addDrug.last_intake < year){
      const response = await createDrug(addDrug, id);
      if (response.data) {
        toast.success(response.data.message);
        setIsSelected("Illicit Drug Use");
        setAddDrug({ name: "", last_intake: "" });
        fetchDrug();
      }
    }
    setShowButton(false);
  }
  async function updateDrug() {
    setShowButton(true);
    if (validateDrug(addDrug, setError)) {
      const response = await editDrug(addDrug, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddDrug({ name: "", last_intake: "" });
        setIsEdit("");
        fetchDrug();
      }
    }
    setShowButton(false);
  }
  async function deleteDrugUse() {
    const response = await deleteDrug(addDrug.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddDrug({ name: "", last_intake: "" });
      fetchDrug();
    }
  }
  async function fetchDrug() {
    setShowLoader(true);
    const response = await getDrug({ patient_id: id.id });
    if (response.data) {
      setDrugDatas(response.data.data);
    } else {
      setDrugDatas([]);
    }
    setShowLoader(false);
  }
  // ===============================================

  /** API -- HERBAL USE */
  async function addHerbalUse() {
    setShowButton(true);
    if (validateHerbal(addHerbal, setError)) {
      const response = await createHerbal(addHerbal, id);
      if (response.status !== 200) {
        toast.error(response.response.data.messages.error_messages[0]);
      } else {
        toast.success(response.data.message);
        setIsSelected("Herbal Use");
        setAddHerbal({
          name: "",
          duration: "",
          last_intake: "",
        });
        fetchHerbal();
      }
    } else {
    }
    setShowButton(false);
  }
  async function updateHerbal() {
    setShowButton(true);
    if (validateHerbal(addHerbal, setError)) {
      const response = await editHerbal(addHerbal, id);
      if (response.data.status !== 200) {
        toast.error(response.data.messages);
      } else {
        toast.success(response.data.data.message);
        setAddHerbal({
          name: "",
          duration: "",
          last_intake: "",
        });
        setIsEdit("");
        fetchHerbal();
      }
    }
    setShowButton(false);
  }
  async function deleteHerbaluse() {
    const response = await deleteHerbal(addHerbal.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddHerbal({ name: "", duration: "", last_intake: "" });
      fetchHerbal();
    }
  }
  async function fetchHerbal() {
    setShowLoader(true);
    const response = await getHerbal({ patient_id: id.id });
    if (response.data) {
      setHerbalDatas(response.data.data);
    } else {
      setHerbalDatas([]);
    }
    setShowLoader(false);
  }

  //Sexual Activity
  async function addSexualActivitySubmit() {
    setShowButton(true);
    const response = await createSexualActivity(addSexualActivity, id);
    if (response.status !== 200) {
      toast.error(response.response.data.messages.error_messages[0]);
    } else {
      toast.success(response.data.message);
      setIsSelected("Sexual Activity");
      setAddSexualActivity({ is_sexually_active: "0" });
      fetchSexualActivity();
    }
    setShowButton(false);
  }
  async function updateSexualActivity() {
    setShowButton(true);
    const response = await editSexualActivity(addSexualActivity, id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setAddSexualActivity({ is_sexually_active: "0" });
      setIsEdit("");
      fetchSexualActivity();
    }
    setShowButton(false);
  }
  async function deleteSexualActivity() {
    const response = await deleteSexualActivity(addSexualActivity.id);
    if (response.data.status !== 200) {
      toast.error(response.data.messages);
    } else {
      toast.success(response.data.data.message);
      setShowDelete(false);
      setIsEdit("");
      setAddSexualActivity({ is_sexually_active: "0" });
      fetchSexualActivity();
    }
  }
  async function fetchSexualActivity() {
    setShowLoader(true);
    const response = await getSexualActivity({ patient_id: id.id });
    if (response.data) {
      const rows = (response.data.data || []).map((item) => ({
        ...item,
        is_sexually_active: item?.is_sexually_active ?? item?.is_active ?? "0",
        formatted_is_sexually_active:
          (item?.is_sexually_active ?? item?.is_active) === "1"
            ? "Yes"
            : "No",
      }));
      setSexualActivityData(rows);
      setAddSexualActivity({
        is_sexually_active: rows?.[0]?.is_sexually_active ?? "0",
      });
    } else {
      setSexualActivityData([]);
    }
    setShowLoader(false);
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const handleActionChange = (e, row, type, form) => {
    if (type === "edit") {
      if (form === "herbal") {
        setAddHerbal(row);
        setIsEdit(type);
      } else if (form === "smoking") {
        setAddSmoking(row);
        setIsEdit(type);
      } else if (form === "drinking") {
        setAddDrinking(row);
        setIsEdit(type);
      } else if (form === "drug") {
        setAddDrug(row);
        setIsEdit(type);
      } else if (form === "sexual") {
        setAddSexualActivity({
          ...row,
          is_sexually_active: row?.is_sexually_active ?? row?.is_active ?? "0",
        });
        setIsEdit(type);
      }
    } else if (type === "delete") {
      if (form === "herbal") {
        setAddHerbal(row);
        setShowDelete(true);
      } else if (form === "smoking") {
        setAddSmoking(row);
        setShowDelete(true);
      } else if (form === "drinking") {
        setAddDrinking(row);
        setShowDelete(true);
      } else if (form === "drug") {
        setAddDrug(row);
        setShowDelete(true);
      } else if (form === "sexual") {
        setAddSexualActivity(row);
        setShowDelete(true);
      }
    }
  };
  function ActionBtn(row, form) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            id={"edit"}
            name={"edit"}
            label={"Edit"}
            size={"sm"}
            onClick={(e) => handleActionChange(e, row.row, "edit", form)}
          />
        </Col>
        {(role === "director" || role === "pcp" || role === "specialist") && (
          <Col>
            <BtnDelete
              label={"Delete"}
              size={"sm"}
              onClick={(e) => handleActionChange(e, row.row, "delete", form)}
            />
          </Col>
        )}
      </Row>
    );
  }

  React.useEffect(() => {
    if (isSelected === "Smoking") fetchSmoking();
    else if (isSelected === "Drinking") fetchDrinking();
    else if (isSelected === "Illicit Drug Use") fetchDrug();
    else if (isSelected === "Herbal Use") fetchHerbal();
    else if (isSelected === "Sexual Activity") fetchSexualActivity();
    setAddHerbal({});
    setAddSmoking({});
    setAddDrinking({
      frequency: "occasional",
      consumption: "light",
      btl_per_day: "",
    });
    setAddDrug({});
    setIsEdit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected]);

  return (
    <div className={!isMedicalHistory ? "" : "card-with-table p-3"}>
      {/* <ToastContainer /> */}
      <div className="row">
        {isMedicalHistory && (
          <div className="col p-3 me-2 pt-2">
            <>
              <div className="col mb-4 pt-1">
                <div className="row">
                  <div className="col">
                    <h5 className="font-bold">SOCIAL/PERSONAL HISTORY</h5>
                  </div>
                  <div className="col-3">
                    <BtnAdd
                      label={"+ Add New Entry"}
                      onClick={() => setIsMedicalHistory(false)}
                    />
                  </div>
                </div>
              </div>
              <SocialPersonalHistorySummary
                isVisible
                setSelectedItem={setSelectedItem}
                setIsMedicalHistory={() => setIsMedicalHistory()}
                setIsSelected={setIsSelected}
              />
            </>
          </div>
        )}
        {!isMedicalHistory && (
          <div className="col-2 p-3 header-btn manager-container pt-2 show-summary-container">
            <div className="row mt-1 pt-1">
              <div className="col">
                <BtnAdd
                  label={"Show Summary"}
                  onClick={() => setIsMedicalHistory(true)}
                />
              </div>
            </div>
            <div className="row mt-1.s">
              <List className="list-tab-cont">
                {listTabs.map((data, index) => {
                  return (
                    <List.Item
                      key={index}
                      className={`p-1 px-2 m-1 fs-small text-start list-item ${
                        selectedItem === index ? "selected" : ""
                      }`}
                      onClick={(e) => handleChange(data, index)}
                    >
                      {data.label}
                    </List.Item>
                  );
                })}
              </List>
            </div>
          </div>
        )}
        {!isMedicalHistory && (
          <div className="col-10 show-second-container">
            {isSelected === "Smoking" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {" "}
                    {isEdit === "edit" ? "Edit Smoking" : "Smoking"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      onChange={handleAddSmokingChange}
                      value={addSmoking.duration}
                      isError={isError.duration}
                      errorMessage="Duration field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="sticks_per_day"
                      type={``}
                      formLabel={`Sticks Per Day`}
                      size={`sm`}
                      name="sticks_per_day"
                      onChange={handleAddSmokingChange}
                      value={addSmoking.sticks_per_day}
                      isError={isError.sticks_per_day}
                      errorMessage="Stick per day field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit" ? updateSmoking : addSmokingSubmit
                      }
                      isClicked={showButton}
                      disabled={
                        !addSmoking.duration || !addSmoking.sticks_per_day
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["DURATION", "STICKS PER DAY"]}
                      headerSelector={["duration", "sticks_per_day"]}
                      tableData={smokingData}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "smoking")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Drinking" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Drinking" : "Drinking"}{" "}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <SelectField
                      // required
                      formLabel={`Frequency`}
                      name="frequency"
                      size={`sm`}
                      placeholder={"Select"}
                      options={[
                        // { value: "", label: "Select" },
                        { value: "occasional", label: "Occasional" },
                        { value: "frequent", label: "Frequent" },
                      ]}
                      value={addDrinking.frequency}
                      onChange={handleAddDrinkingChange}
                      isError={isError.frequency}
                      errorMessage="Frequency field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <SelectField
                      required
                      formLabel={`Consumption`}
                      name="consumption"
                      size={`sm`}
                      placeholder={"Select"}
                      options={[
                        // { value: "", label: "Select" },
                        { value: "light", label: "Light" },
                        { value: "moderate", label: "Moderate" },
                        { value: "heavy", label: "Heavy" },
                      ]}
                      value={addDrinking.consumption}
                      onChange={handleAddDrinkingChange}
                      isError={isError.consumption}
                      errorMessage="Consumption field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="btl_per_day"
                      type={``}
                      formLabel={`Bottle/s Per Day`}
                      size={`sm`}
                      name="btl_per_day"
                      onChange={handleAddDrinkingChange}
                      value={addDrinking.btl_per_day}
                      isError={isError.btl_per_day}
                      errorMessage="Bottle/s per day field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="d-flex flex-row-reverse row mb-3">
                    <div className="col-sm-3 me-4 show-summarry-all-buttons">
                      <BtnSave
                        label={isEdit === "edit" ? "Save changes" : "Submit"}
                        onClick={
                          isEdit === "edit" ? updateDrinking : addDrinkingSubmit
                        }
                        isClicked={showButton}
                        disabled={!addDrinking.btl_per_day}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row card-table justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={[
                        "FREQUENCY",
                        "CONSUMPTION",
                        "BOTTLE/S PER DAY",
                      ]}
                      headerSelector={[
                        "frequency",
                        "consumption",
                        "btl_per_day",
                      ]}
                      tableData={drinkingDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "drinking")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Illicit Drug Use" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit"
                      ? "Edit Illicit Drug Use"
                      : "Illicit Drug Use"}
                  </h6>
                  <hr />
                </div>
                <div className="d-flex row align-items-end mb-3 pl-4 pt-3">
                  <div className="col-sm-4">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addDrug.name}
                      onChange={handleAddDrugChange}
                      isError={isError.name}
                      errorMessage="Name field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4">
                    <DateField
                      required
                      id="last_intake"
                      type={``}
                      formLabel={`Last Intake`}
                      size={`sm`}
                      name="last_intake"
                      value={addDrug.last_intake}
                      onChange={handleAddDrugChange}
                      isError={isError.last_intake}
                      errorMessage="Last intake field is required."
                      disabled={showButton}
                    />
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={isEdit === "edit" ? updateDrug : addDrugUse}
                      isClicked={showButton}
                      disabled={!addDrug.name || !addDrug.last_intake}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME", "LAST INTAKE"]}
                      headerSelector={["name", "last_intake"]}
                      tableData={drugDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "drug")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isSelected === "Herbal Use" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">
                    {isEdit === "edit" ? "Edit Herbal Use" : "Herbal Use"}
                  </h6>
                  <hr />
                </div>
                <div className="row pl-4 pt-3">
                  <div className="col">
                    <TextField
                      required
                      id="name"
                      type={``}
                      formLabel={`Name`}
                      size={`sm`}
                      name="name"
                      value={addHerbal.name}
                      onChange={handleAddHerbalChange}
                      isError={isError.name}
                      errorMessage="Name field is required"
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <DateField
                      required
                      id="last_intake"
                      type={``}
                      formLabel={`Last Intake`}
                      size={`sm`}
                      name="last_intake"
                      value={addHerbal.last_intake}
                      onChange={handleAddHerbalChange}
                      isError={isError.last_intake}
                      errorMessage="Last intake field is required"
                      disabled={showButton}
                    />
                  </div>
                  <div className="col">
                    <TextField
                      required
                      id="duration"
                      type={``}
                      formLabel={`Duration`}
                      size={`sm`}
                      name="duration"
                      value={addHerbal.duration}
                      onChange={handleAddHerbalChange}
                      isError={isError.duration}
                      errorMessage="Duration field is required"
                      disabled={showButton}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row-reverse row mb-3">
                  <div className="col-sm-3 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={isEdit === "edit" ? updateHerbal : addHerbalUse}
                      isClicked={showButton}
                      disabled={
                        !addHerbal.name ||
                        !addHerbal.last_intake ||
                        !addHerbal.duration
                      }
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["NAME", "LAST INTAKE", "DURATION"]}
                      headerSelector={["name", "last_intake", "duration"]}
                      tableData={herbalDatas}
                      loading={showLoader}
                      isClickable={false}
                      ActionBtn={(row) => ActionBtn(row, "herbal")}
                      withAction={true}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}

            {isSelected === "Sexual Activity" && (
              <div className="row assessment-hist-cont mt-2 pt-2">
                <div className="row pl-4 pt-2">
                  <h6 className="font-bold">Sexual Activity</h6>
                  <hr />
                </div>
                <div className="row ms-3">
                  <div className="col-4">
                    <p className="form-label align-left">Is sexually active?</p>
                    <Radio.Group
                      className="mt-2 d-flex gap-3 justify-content-start"
                      name="is_sexually_active"
                      value={addSexualActivity?.is_sexually_active}
                      onChange={handleSexualActivityChange}
                    >
                      <Radio value="1">Yes</Radio>
                      <Radio value="0">No</Radio>
                    </Radio.Group>
                  </div>
                  <div className="col-sm-4 mb-2 show-summarry-all-buttons">
                    <BtnSave
                      label={isEdit === "edit" ? "Save changes" : "Submit"}
                      onClick={
                        isEdit === "edit"
                          ? updateSexualActivity
                          : addSexualActivitySubmit
                      }
                      isClicked={showButton}
                      disabled={!addSexualActivity.is_sexually_active}
                    />
                  </div>
                </div>
                <hr />
                <div className="row justify-content-left">
                  <div className="col-sm-12 overflow">
                    <AntDTable
                      tableHeaders={["IS SEXUALLY ACTIVE", "ADDED ON"]}
                      headerSelector={[
                        "formatted_is_sexually_active",
                        "added_on",
                      ]}
                      tableData={SexualActivityData}
                      loading={showLoader}
                      isClickable={false}
                      withAction={false}
                      scroll={{ x: true }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={`Are you sure you want to delete?`}
        onDelete={
          isSelected === "Herbal Use"
            ? deleteHerbaluse
            : isSelected === "Smoking"
            ? deleteSmokingSubmit
            : isSelected === "Drinking"
            ? deleteDrinkingSubmit
            : isSelected === "Illicit Drug Use"
            ? deleteDrugUse
            : isSelected === "Sexual Activity"
            ? deleteSexualActivity
            : () => alert(`Error calling delete api of ${isSelected}`)
        }
      />
    </div>
  );
}
export default AddSocialPersonal;
